import React from 'react';

import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import { withMediaQueries } from 'hoc/withMediaQueries';

import MainFont from 'ui/typography/mainFont';

import Icon from '../Icon';
import { GoBackContainer } from './style';

// eslint-disable-next-line import/no-cycle

const GoBack = ({
  text = 'Back',
  iconSize = 16,
  typeMainFont = 'bold',
  mediaIsPhone,
  onClick
}) => {
  const history = useHistory();

  const handleOnClick = () => {
    if (onClick) {
      onClick();
    } else {
      history.goBack();
    }
  };

  return (
    <GoBackContainer onClick={handleOnClick}>
      <Icon type="icon-up" size={mediaIsPhone ? 14 : iconSize} />
      <MainFont type={typeMainFont} configuration={{ fontSize: 14 }}>
        {text}
      </MainFont>
    </GoBackContainer>
  );
};

GoBack.propTypes = {
  text: PropTypes.string,
  iconSize: PropTypes.number,
  typeMainFont: PropTypes.string,
  mediaIsPhone: PropTypes.bool
};

export default withMediaQueries(GoBack);
